var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MsAjaxTemplate',{ref:"tmpl",attrs:{"template-name":"entries","get-template-data":_vm.getTemplateData,"ready-dependencies":['init-entries']}})
}
var staticRenderFns = []

export { render, staticRenderFns }